module.exports = __webpack_public_path__ + "media/img/Landing_Page/logos/19-23c450058c370d25120a7ac491adce19.jpg";